const AboutTeamCard = ({ name, img }) => {
  return (
    <div className="w-[320px] h-[380px] bg-green-400 rounded-lg group relative cursor-pointer overflow-hidden">
      <img className="rounded-lg w-full h-full object-cover" src={img} alt="" />
      <h5 className="bg-slate-400 font-bold py-2 opacity-90 absolute bottom-20 right-[-80%] z-10 w-[60%] transition-all duration-500 text-center -skew-x-6 group-hover:right-0">
        {name}
      </h5>
      <h3 className="bg-gradient-to-tr py-2 text-center w-[80%] -skew-x-6  opacity-90 from-[#FE4904] to-[#F7164C] absolute bottom-[40px] transition-all duration-500 delay-200 right-[-80%] text-white  group-hover:right-0">
        Market Analyst
      </h3>
    </div>
  );
};
export default AboutTeamCard;
